export const PATHNAMES = {
  HOME: "/",
  BLOG: "/blog",
  BLOG_ITEM: (slug: string) => `/blog/${slug}`,

  CALCULATOR: "/calculator",

  NOT_FOUND: "/*",
} as const;
